export default __webpack_public_path__ + "static/media/fig-13-pressure-shaft.8b0c126c.png";